if (!customElements.get('mdm-footer-menu')) {
  customElements.define('mdm-footer-menu', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.media = window.matchMedia('(min-width: 750px)');
      this.sync = () => {
        this.details.open = this.media.matches;
        if (this.media.matches) this.summary.setAttribute('tabindex', '-1');
        else this.summary.removeAttribute('tabindex');
      };
      this.preventDesktopToggle = (event) => {
        if (this.media.matches) event.preventDefault();
      };
      this.media.addEventListener('change', this.sync);
      this.summary.addEventListener('click', this.preventDesktopToggle);
      this.sync();
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.sync);
      this.summary?.removeEventListener('click', this.preventDesktopToggle);
    }
  });
}
